import React, { useState, useEffect } from 'react'

function KnovaInput(props) {
  const {
    contBgColor,
    contBorderWidth,
    contBorderColor,
    contPadding,
    contMargin,
    contBorderRadius,
    contWidth
  } = props
  const {
    text,
    textColor,
    textFontSize,
    textFontWeight,
    textFontFamily,
    textHeight,
    letterSpacing,
    textOpacity,
    onTextChage
  } = props

  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(text)
  }, [text])

  return (
    <input
      style={{
        width: contWidth ? '100px' : '100%',
        backgroundColor: contBgColor ? contBgColor : 'transparent',
        borderWidth: contBorderWidth ? contBorderWidth : '0px',
        borderStyle: contBorderWidth ? 'solid' : 'none',
        borderColor: contBorderColor ? contBorderColor : '',
        borderRadius: contBorderRadius ? contBorderRadius : '0px',
        padding: contPadding ? contPadding : '0px',
        margin: contMargin ? contMargin : '0px',
        color: textColor ? textColor : '#000',
        fontSize: textFontSize ? textFontSize : '20px',
        fontWeight: textFontWeight ? textFontWeight : 'normal',
        fontFamily: textFontFamily ? textFontFamily : 'unset',
        whiteSpace: 'pre-line',
        lineHeight: textHeight,
        letterSpacing: letterSpacing,
        opacity: textOpacity ? textOpacity : 1
      }}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={() => {
        onTextChage(value)
      }}
      onKeyDown={(ev) => {
        if (ev.key === 'Enter') {
          ev.target.blur()
        } else if (ev.key === 'ArrowDown') {
          ev.target.blur()
        }
        // else if (ev.key === 'Tab') {
        //   if (ev.target.value.trim().length === 0) {
        //     ev.preventDefault()
        //     return
        //   }
        // }
      }}
    ></input>
  )
}
export { KnovaInput }
